import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AppContext } from '../../../../AppContext';
import { useContentRepoFetch } from '../../../../libs/data-access/src/ContentRepository/useContentRepoFetch';
import { showToast } from '../../../../utils/utility';
import { useMasterFetch } from '../../../../libs/data-access';
import { handleValidContentRepository } from '../../../../utils/validators';

const useContentRepository = () => {
  const DEFAULT_ITEMS_PER_PAGE = 8;
  const { role, user } = useContext(AppContext);
  const { fetchContentRepoData, postContentRepoData } = useContentRepoFetch();
  const { fetchMasterData } = useMasterFetch();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [contentRepositoryAllData, setContentCategoryAllData] = useState<any[]>([]);
  const [contentRepositoryData, setContentRepositoryData] = useState<any[]>([
    {
      RepositoryName: "Maths",
      RepositoryDescription: "Maths Content",
      Category: "Testing",
      created_on: "2023-10-01",
    },
    {
      RepositoryName: "Science",
      RepositoryDescription: "Science Content",
      Category: "Testing",
      created_on: "2023-10-02",
    },
    {
      RepositoryName: "English",
      RepositoryDescription: "English Content",
      Category: "Testing",
      created_on: "2023-10-03",
    },
  ]);
  const [contentRepositoryDetails, setContentRepositoryDetails] = useState<any>(
    {
      content_Title: "",
      content_Description: "",
      content_Category_Id: "",
      user_Id: `${user.role_Id}`,
      content_Url: "",
      content_For_Role_Id: "",
    }
  );

  const [search, setSearch] = useState("");

  const [category, setCategory] = useState<any[]>([]);

  const [roles, setRoles] = useState<any[]>([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);

  const [totalRecords, setTotalRecords] = useState(10);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmPayload, setConfirmPayload] = useState<any>(null);

  const nextPage = () => setCurrentPage(currentPage + 1);
  const prevPage = () => setCurrentPage(currentPage - 1);

  const handleChangeRepository = ({
    name,
    value,
  }: {
    name: string;
    value: any;
  }) => {
    setContentRepositoryDetails((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getContentRepositoryApi = async (current?: any) => {
    setLoading(true);
    // const res = await fetchContentRepoData(
    //   `GetContentRepository/${currentPage * itemsPerPage}/${itemsPerPage}`
    // );
    const res = await fetchContentRepoData(
      `GetContentRepository`
    );
    if (res.isSuccess) {
      setCurrentPage(0);
      setContentCategoryAllData(res?.data);
      setItemsPerPage(DEFAULT_ITEMS_PER_PAGE);
      let data = res?.data?.slice(
        0,
        itemsPerPage
      );
      setContentRepositoryData(data);
      setTotalRecords(res?.data[0]?.total);
    } else {
      setContentCategoryAllData([]);
      setContentRepositoryData([]);
      showToast({
        type: "error",
        message: res.message || "Something went wrong",
      });
    }

    setLoading(false);
  };

  const onchangeSingalContent = (id: any) => {
    let singalData = contentRepositoryData?.find(
      (item: any) => item?.content_Repository_Id === id
    );
    if (singalData) {
      setContentRepositoryDetails({
        content_Title: singalData?.content_Title,
        content_Description: singalData?.content_Description,
        content_Category_Id: String(singalData?.content_Category_Id),
        user_Id: `${user.role_Id}`,
        content_Url: singalData?.content_Url,
        content_For_Role_Id: String(singalData?.content_For_Role_Id),
        content_Repository_Id: singalData?.content_Repository_Id,
      });
      setOpen(true);
    }
  };


  const saveContentRepository = async ({ type, status, id }: any) => {
    let payload = {
      ...contentRepositoryDetails,
      content_Category_Id: Number(
        contentRepositoryDetails?.content_Category_Id
      ),
      content_For_Role_Id: Number(
        contentRepositoryDetails?.content_For_Role_Id
      ),
      user_Id: Number(contentRepositoryDetails.user_Id),
      content_Repository_Id: id
        ? id
        : contentRepositoryDetails?.content_Repository_Id
        ? contentRepositoryDetails?.content_Repository_Id
        : 0,
      is_Edit:
        type === "insert"
          ? 1
          : type === "Update"
          ? 2
          : type === "delete"
          ? 3
          : 0,
      is_active: status === "active" ? 1 : 0,
    };
    let valid;
    if (id) {
      valid = true;
    } else {
      valid = handleValidContentRepository(contentRepositoryDetails);
    }
    if (valid) {
      const res = await postContentRepoData(
        `AddUpdateDeleteContentRepository`,
        payload
      );
      if (res.isSuccess) {
        showToast({
          type: "success",
          message: res.message,
        });
        setContentRepositoryDetails({
          content_Title: "",
          content_Description: "",
          content_Category_Id: "",
          user_Id: `${user.role_Id}`,
          content_Url: "",
          content_For_Role_Id: "",
        });

        getContentRepositoryApi();
        setOpen(false);
      } else {
        showToast({
          type: "error",
          message: res.message,
        });
        // setContentRepositoryDetails({
        //   content_Title: "",
        //   content_Description: "",
        //   content_Category_Id: "",
        //   user_Id: `${user.role_Id}`,
        //   content_Url: "",
        //   content_For_Role_Id: "",
        // });
      }
    }
  };

  const getContentCategoryApi = async (current?: any) => {
    // const res = await fetchContentRepoData(
    //   `GetContentRepositoryCategoryMaster/${0}/${100}`
    // );
        const res = await fetchContentRepoData(
          `GetContentRepositoryCategoryMaster`
        );
    if (res.isSuccess) {
      setCategory(res?.data);
    } else {
      setCategory([]);
      showToast({
        type: "error",
        message: res.message || "Something went wrong",
      });
    }
  };

  const getAllROlesApi = async (current?: any) => {
    const res = await fetchMasterData(`GetAllRoles`);
    if (res.isSuccess) {
      setRoles(res?.data);
    } else {
      setRoles([]);
      showToast({
        type: "error",
        message: res.message || "Something went wrong",
      });
    }
  };

    const onCloseModal = () => {
      setOpen(false);
      setContentRepositoryDetails({
        content_Title: "",
        content_Description: "",
        content_Category_Id: "",
        user_Id: `${user.role_Id}`,
        content_Url: "",
        content_For_Role_Id: "",
      });
    };

  // Called when user toggles the switch -> open confirm modal
  const handleToggleRequest = (id: any, currentlyActive: boolean) => {
    const status = currentlyActive ? "inactive" : "active";
    setConfirmPayload({ id, status });
    setConfirmOpen(true);
  };

  // Confirm pressed -> call API via hook
  const handleConfirmToggle = async () => {
    if (!confirmPayload) return;
    // Use Update type for toggle (keeps parity with your hook)
    await saveContentRepository({
      type: "delete",
      status: confirmPayload?.status,
      id: confirmPayload?.id,
    });
    setConfirmOpen(false);
    setConfirmPayload(null);
  };

  const handleCancelToggle = () => {
    setConfirmOpen(false);
    setConfirmPayload(null);
  };

  useEffect(() => {
    // for setting current Page to 1 after search
    //  if (search.trim() && currentPage !== 0) {
    //    setCurrentPage(0);
    //    return;
    //  }
    // for setting current Page to 1 after search
    if (search.trim()) {
      let filteredData = contentRepositoryAllData.filter((item) =>
        item.content_Title?.toLowerCase().includes(search.toLowerCase())
      );
      setTotalRecords(filteredData?.length);
      setItemsPerPage(filteredData?.length);
      setContentRepositoryData(filteredData);
      return;
    }
    setTotalRecords(contentRepositoryAllData?.length);
    setItemsPerPage(DEFAULT_ITEMS_PER_PAGE);
    let data = contentRepositoryAllData?.slice(
      currentPage * DEFAULT_ITEMS_PER_PAGE,
      currentPage * DEFAULT_ITEMS_PER_PAGE + DEFAULT_ITEMS_PER_PAGE
    );
    setContentRepositoryData(data);
  }, [search, contentRepositoryAllData, currentPage]);

  useEffect(() => {
    getContentCategoryApi();
    getAllROlesApi();
    getContentRepositoryApi();
  }, []);


  //  useEffect(() => {
  //    let data = contentRepositoryAllData?.slice(
  //      currentPage * itemsPerPage,
  //      currentPage * itemsPerPage + itemsPerPage
  //    );
  //    setContentRepositoryData(data);
  //  }, [currentPage]);

  return {
    loading,
    contentRepositoryDetails,
    contentRepositoryData,
    open,
    setOpen,
    handleChangeRepository,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalRecords,
    prevPage,
    nextPage,
    category,
    roles,
    saveContentRepository,
    onchangeSingalContent,
    confirmOpen,
    setConfirmOpen,
    confirmPayload,
    setConfirmPayload,
    handleConfirmToggle,
    handleToggleRequest,
    handleCancelToggle,
    onCloseModal,
    search,
    setSearch,
    contentRepositoryAllData,
  };
};

export default useContentRepository